import { ICellEditorParams } from '@ag-grid-enterprise/all-modules'
import { Nullable } from '@/shared/types/app.types'

export interface CheckIconCellEditorParams<T> extends ICellEditorParams {
    value: Nullable<boolean>
    allowEmpty?: boolean
    isPopup?: boolean
}

export interface CheckIconModel {
    value: boolean
    label?: string
    icon?: string
}

export interface CheckIconCellEditorState {
    value: Nullable<CheckIconModel>
}
export const initialCheckIconCellEditorState =
    (): CheckIconCellEditorState => ({
        value: null
    })
